// extracted by mini-css-extract-plugin
export default {"input-text-container":"styles_input-text-container__+cfBb"};